import { Typography } from '@material-ui/core'
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import InfoIcon from '@material-ui/icons/InfoOutlined'
import classNames from 'classnames'
import React from 'react'

const styles = (theme: Theme) =>
  createStyles({
    container: {
      flex: '1',
      display: 'flex',
      padding: `5px 10px`,
      background: '#E0ECF8',
      borderRadius: 4,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    message: {
      marginLeft: theme.spacing(),
      fontSize: '13px',
      color: theme.palette.primary.dark,
    },
    icon: {
      color: theme.palette.primary.dark,
      fontSize: '22px',
    },
  })

interface IProps extends WithStyles {
  className?: string
  message: string
  showBanner: boolean
}

const InformationBanner = (props: IProps) => {
  const { classes, className, showBanner = true, message } = props

  if (!showBanner) {
    return null
  }

  return (
    <div className={classNames(classes.container, className)}>
      <InfoIcon className={classes.icon} />
      <Typography className={classes.message}>{message}</Typography>
    </div>
  )
}

export default withStyles(styles)(InformationBanner)
